import { useState, type FormEvent } from "react";
import { api, errMsg } from "../api";
import { TwoFactorEnroll } from "../components/TwoFactorEnroll";
import { Btn, Field, Input, Notice, PageHead } from "../components/ui";
import { useMe } from "../session";

export function Security({ embedded = false }: { embedded?: boolean }) {
  const { me, reload } = useMe();
  const realm = me.user.realm;
  const [enrolling, setEnrolling] = useState(false);
  const [msg, setMsg] = useState<{ kind: "ok" | "error"; text: string } | null>(null);

  return (
    <>
      {!embedded && <PageHead title="Segurança" sub="Senha e autenticação em dois fatores." />}
      {msg && <div style={{ maxWidth: 560 }}><Notice kind={msg.kind}>{msg.text}</Notice></div>}

      <div className="card" style={{ maxWidth: 560, marginBottom: 16 }}>
        <h3 style={{ fontSize: 16, marginBottom: 8 }}>Autenticação em dois fatores (2FA)</h3>
        {me.security.totpMandatory && <p className="muted" style={{ marginTop: 0 }}>Obrigatória para perfis administrativos e não pode ser desativada.</p>}
        {me.security.totpEnabled && !enrolling ? (
          <>
            <p style={{ marginTop: 0 }}><span className="pill accent">Ativada</span></p>
            {!me.security.totpMandatory && <DisableForm hasPassword onDone={() => { setMsg({ kind: "ok", text: "2FA desativado." }); void reload(); }} onError={(t) => setMsg({ kind: "error", text: t })} />}
          </>
        ) : enrolling ? (
          <TwoFactorEnroll realm={realm} onFinished={() => { setEnrolling(false); setMsg({ kind: "ok", text: "2FA ativado." }); void reload(); }} />
        ) : (
          <>
            <p className="muted" style={{ marginTop: 0 }}>Opcional para clientes. Adiciona uma segunda verificação no login.</p>
            <Btn onClick={() => { setMsg(null); setEnrolling(true); }}>Ativar 2FA</Btn>
          </>
        )}
      </div>

      <PasswordForm onDone={() => setMsg({ kind: "ok", text: "Senha alterada. Outras sessões foram encerradas." })} onError={(t) => setMsg({ kind: "error", text: t })} />
    </>
  );
}

function DisableForm({ onDone, onError }: { hasPassword: boolean; onDone: () => void; onError: (t: string) => void }) {
  const { me } = useMe();
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  async function submit(e: FormEvent) {
    e.preventDefault();
    try { await api("POST", `/api/${me.user.realm}/security/2fa/disable`, { password, code: code.replace(/\s/g, "") }); onDone(); } catch (e2) { onError(errMsg(e2)); }
  }
  return (
    <form onSubmit={submit}>
      <Field label="Senha atual"><Input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} /></Field>
      <Field label="Código do autenticador"><Input inputMode="numeric" value={code} onChange={(e) => setCode(e.target.value)} /></Field>
      <Btn type="submit" variant="danger">Desativar 2FA</Btn>
    </form>
  );
}

function PasswordForm({ onDone, onError }: { onDone: () => void; onError: (t: string) => void }) {
  const { me } = useMe();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  async function submit(e: FormEvent) {
    e.preventDefault();
    try { await api("POST", `/api/${me.user.realm}/security/password`, { currentPassword: cur, newPassword: next }); setCur(""); setNext(""); onDone(); } catch (e2) { onError(errMsg(e2)); }
  }
  return (
    <form className="card" style={{ maxWidth: 560 }} onSubmit={submit}>
      <h3 style={{ fontSize: 16, marginBottom: 12 }}>Alterar senha</h3>
      <Field label="Senha atual"><Input type="password" autoComplete="current-password" required value={cur} onChange={(e) => setCur(e.target.value)} /></Field>
      <Field label="Nova senha (mínimo 10 caracteres, com letras e números)"><Input type="password" autoComplete="new-password" required minLength={10} value={next} onChange={(e) => setNext(e.target.value)} /></Field>
      <Btn type="submit">Salvar nova senha</Btn>
    </form>
  );
}
